import { connect } from 'react-redux';
import Navigator from './navigator';

const mapStateToProps = state => ({
  routeName: state.navigator.route,
  loggedIn: state.authentication.loggedIn,
});

export default connect(mapStateToProps)(Navigator);



// WEBPACK FOOTER //
// ./src/app/navigator/navigator.container.js